export default {"src":"/_next/static/media/mzc.8b9c9cf2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};